import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxDualListboxComponent } from './components/index/index.component';


export class NgxDualListboxModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: NgxDualListboxModule
    };
  }
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  declarations: [NgxDualListboxComponent],
  imports: [CommonModule],
  exports: [NgxDualListboxComponent]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
